import { render, staticRenderFns } from "./DiscountedProductSlider.vue?vue&type=template&id=03707b16&scoped=true&"
import script from "./DiscountedProductSlider.vue?vue&type=script&lang=js&"
export * from "./DiscountedProductSlider.vue?vue&type=script&lang=js&"
import style0 from "./DiscountedProductSlider.vue?vue&type=style&index=0&id=03707b16&scoped=true&lang=css&"
import style1 from "./DiscountedProductSlider.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03707b16",
  null
  
)

export default component.exports